import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { CELL_LAYOUT_TYPE } from './Types';
import './BooleanDialogEditor.scss';

const UNDEFINED_VALUE = 'UNDEFINED_VALUE';

const BooleanDialogEditor = (props) => {
  const { value, onValueChange, editor, className, style } = props;
  let checked;
  switch (value) {
    case undefined: checked = editor.defaultValue === undefined ? false : editor.defaultValue; break;
    case 'true': checked = true; break;
    case 'false': checked = false; break;
    default: checked = value;
  }
  const handleChange = (event) => {
    onValueChange(event.target.checked === editor.defaultValue ? undefined : event.target.checked, editor);
  };
  if (editor.layout === CELL_LAYOUT_TYPE) {
    return (
      <FormControlLabel
        className={classnames('grb-booleanfilter-editor', 'grb-booleanfilter-cell-editor', className)}
        control={<Checkbox checked={checked} onChange={handleChange} name={editor.name} />}
        label="Secondary"
        style={style}
      />
    );
  }
  return (
    <Checkbox
      checked={checked}
      onChange={handleChange}
      inputProps={{ 'aria-label': editor.title }}
    />
  );
};

BooleanDialogEditor.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
    PropTypes.shape({}),
  ]),
  editor: PropTypes.shape({
    title: PropTypes.string,
    name: PropTypes.string,
    layout: PropTypes.string,
    defaultValue: PropTypes.bool,
  }).isRequired,
  onValueChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.shape({}),
};

BooleanDialogEditor.defaultProps = {
  value: UNDEFINED_VALUE,
  className: undefined,
  style: undefined,
};

export default BooleanDialogEditor;
